<div class="unsubscribe-container">
  <div class="unsubscribe-content">
    <!-- Logo Section -->
    <div class="logo-section">
      <img src="assets/logo-transparent.svg" alt="Hebern Logo" class="logo" />
    </div>

    <!-- Main Message -->
    <div class="unsubscribe-message">
      <h1 class="unsubscribe-title">Manage Your Subscription</h1>
      <p class="unsubscribe-subtitle">
        Control your email preferences for Hebern updates
      </p>
    </div>

    <!-- Subscription Card -->
    <div class="subscription-card">
      <div class="card-content">
        <!-- Loading State -->
        @if (isLoading) {
        <div class="loading-state">
          <div class="loading-spinner"></div>
          <p>Loading your subscription status...</p>
        </div>
        }

        <!-- Error State -->
        @if (errorMessage && !isLoading) {
        <div class="error-state">
          <div class="error-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="#ff4444"
                stroke-width="2"
              />
              <path
                d="m15 9-6 6m0-6 6 6"
                stroke="#ff4444"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <p>{{ errorMessage }}</p>
        </div>
        }

        <!-- Success State -->
        @if (successMessage && !isLoading) {
        <div class="success-state">
          <div class="success-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="#4caf50"
                stroke-width="2"
              />
              <path
                d="m9 12 2 2 4-4"
                stroke="#4caf50"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <p>{{ successMessage }}</p>
        </div>
        }

        <!-- Subscription Status and Toggle -->
        @if (!isLoading && !errorMessage) {
        <div class="subscription-content">
          <div class="status-info">
            <div
              class="status-indicator"
              [class.subscribed]="isSubscribed"
              [class.unsubscribed]="!isSubscribed"
            >
              <div class="status-dot"></div>
              <span class="status-text">
                {{
                  isSubscribed
                    ? "Currently Subscribed"
                    : "Currently Unsubscribed"
                }}
              </span>
            </div>
            <p class="status-description">
              {{
                isSubscribed
                  ? "You are receiving email updates from Hebern about our latest security innovations."
                  : "You are not receiving email updates from Hebern. You can subscribe anytime to stay informed."
              }}
            </p>
          </div>

          <button
            type="button"
            class="toggle-btn"
            [class.subscribe]="!isSubscribed"
            [class.unsubscribe]="isSubscribed"
            [disabled]="isToggling"
            (click)="toggleSubscription()"
          >
            @if (!isToggling) {
            <span>
              {{ isSubscribed ? "Unsubscribe" : "Subscribe" }}
            </span>
            } @if (isToggling) {
            <span class="loading-spinner">
              {{ isSubscribed ? "Unsubscribing..." : "Subscribing..." }}
            </span>
            }
          </button>
        </div>
        }
      </div>
    </div>

    <!-- Footer Message -->
    <div class="footer-message">
      <p>Questions? We're here to help. Reach out to us anytime.</p>
      <p class="email-link">
        <a href="mailto:support@hebern.com">support@hebern.com</a>
      </p>
    </div>
  </div>
</div>
